import { Component } from '@angular/core';
import { TeamActionMockSettingsService } from '../../team-action-mock-settings.service';
import { MOCK_SUPPORT, MOCK_TEAMS, teamMembersLabel } from '../../team-action-mock.data';

// Maquette d'estimation « action d'équipe » : équipe fictive désignée en Validateurs N+1, dans le vrai éditeur des acteurs achat.
@Component({
  selector: 'team-action-mock-purchase-actor-team',
  templateUrl: './team-action-mock-purchase-actor-team.component.html',
})
export class TeamActionMockPurchaseActorTeamComponent {
  readonly team = MOCK_TEAMS.validators;
  readonly support = MOCK_SUPPORT;
  readonly membersLabel = teamMembersLabel(this.team);

  constructor(public settings: TeamActionMockSettingsService) {}
}
